import { render, staticRenderFns } from "./VwaType.vue?vue&type=template&id=53e73d54&"
import script from "./VwaType.vue?vue&type=script&lang=ts&"
export * from "./VwaType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports